export default __webpack_public_path__ + "static/media/calculator.13bd5037.png";